/**
 * Format a date string into YYYY-MM-DD format.
 * @param {string | Date} date - The date to format (can be a string or a Date object).
 * @returns {string | null} - The formatted date as YYYY-MM-DD or null if no date is provided.
 */
export const formatDate = (date) => {
    if (!date) return null;
    
    const parsedDate = new Date(date);
    if (isNaN(parsedDate)) return null;
    
    return parsedDate.toISOString().split('T')[0];
};